import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["open", "onFormSubmitted"];
import "regenerator-runtime/runtime.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import { GLOBAL_OBJ, getClient, getCurrentScope, captureFeedback, getLocationHref, isBrowser, addIntegration, logger, getIsolationScope, getGlobalScope } from '@sentry/core';

// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
var WINDOW = GLOBAL_OBJ;
var DOCUMENT = WINDOW.document;
var NAVIGATOR = WINDOW.navigator;
var TRIGGER_LABEL = 'Report a Bug';
var CANCEL_BUTTON_LABEL = 'Cancel';
var SUBMIT_BUTTON_LABEL = 'Send Bug Report';
var CONFIRM_BUTTON_LABEL = 'Confirm';
var FORM_TITLE = 'Report a Bug';
var EMAIL_PLACEHOLDER = 'your.email@example.org';
var EMAIL_LABEL = 'Email';
var MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
var MESSAGE_LABEL = 'Description';
var NAME_PLACEHOLDER = 'Your Name';
var NAME_LABEL = 'Name';
var SUCCESS_MESSAGE_TEXT = 'Thank you for your report!';
var IS_REQUIRED_LABEL = '(required)';
var ADD_SCREENSHOT_LABEL = 'Add a screenshot';
var REMOVE_SCREENSHOT_LABEL = 'Remove screenshot';
var FEEDBACK_WIDGET_SOURCE = 'widget';
var FEEDBACK_API_SOURCE = 'api';
var SUCCESS_MESSAGE_TIMEOUT = 5000;

/**
 * Public API to send a Feedback item to Sentry
 */
var sendFeedback = function sendFeedback(params) {
  var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    includeReplay: true
  };
  if (!params.message) {
    throw new Error('Unable to submit feedback with empty message');
  }

  // We want to wait for the feedback to be sent (or not)
  var client = getClient();
  if (!client) {
    throw new Error('No client setup, cannot send feedback.');
  }
  if (params.tags && Object.keys(params.tags).length) {
    getCurrentScope().setTags(params.tags);
  }
  var eventId = captureFeedback(_objectSpread({
    source: FEEDBACK_API_SOURCE,
    url: getLocationHref()
  }, params), hint);

  // We want to wait for the feedback to be sent (or not)
  return new Promise(function (resolve, reject) {
    // After 5s, we want to clear anyhow
    var timeout = setTimeout(function () {
      return reject('Unable to determine if Feedback was correctly sent.');
    }, 5000);
    var cleanup = client.on('afterSendEvent', function (event, response) {
      if (event.event_id !== eventId) {
        return;
      }
      clearTimeout(timeout);
      cleanup();

      // Require valid status codes, otherwise can assume feedback was not sent successfully
      if (response && typeof response.statusCode === 'number' && response.statusCode >= 200 && response.statusCode < 300) {
        return resolve(eventId);
      }
      if (response && typeof response.statusCode === 'number' && response.statusCode === 0) {
        return reject('Unable to send Feedback. This is because of network issues, or because you are using an ad-blocker.');
      }
      if (response && typeof response.statusCode === 'number' && response.statusCode === 403) {
        return reject('Unable to send Feedback. This could be because this domain is not in your list of allowed domains.');
      }
      return reject('Unable to send Feedback. This could be because of network issues, or because you are using an ad-blocker');
    });
  });
};

/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

/**
 * Mobile browsers do not support `mediaDevices.getDisplayMedia` even though they have the api implemented
 * Instead they return things like `NotAllowedError` when called.
 *
 * It's simpler for us to browser sniff first, and avoid loading the integration if we can.
 *
 * https://stackoverflow.com/a/58879212
 * https://stackoverflow.com/a/3540295
 *
 * `mediaDevices.getDisplayMedia` is also only supported in secure contexts, and return a `mediaDevices is not supported` error, so we should also avoid loading the integration if we can.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia
 */
function isScreenshotSupported() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(NAVIGATOR.userAgent)) {
    return false;
  }
  /**
   * User agent on iPads show as Macintosh, so we need extra checks
   *
   * https://forums.developer.apple.com/forums/thread/119186
   * https://stackoverflow.com/questions/60482650/how-to-detect-ipad-useragent-on-safari-browser
   */
  if (/Macintosh/i.test(NAVIGATOR.userAgent) && NAVIGATOR.maxTouchPoints && NAVIGATOR.maxTouchPoints > 1) {
    return false;
  }
  if (!isSecureContext) {
    return false;
  }
  return true;
}

/**
 * Quick and dirty deep merge for the Feedback integration options
 */
function mergeOptions(defaultOptions, optionOverrides) {
  return _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), optionOverrides), {}, {
    tags: _objectSpread(_objectSpread({}, defaultOptions.tags), optionOverrides.tags),
    onFormOpen: function onFormOpen() {
      optionOverrides.onFormOpen && optionOverrides.onFormOpen();
      defaultOptions.onFormOpen && defaultOptions.onFormOpen();
    },
    onFormClose: function onFormClose() {
      optionOverrides.onFormClose && optionOverrides.onFormClose();
      defaultOptions.onFormClose && defaultOptions.onFormClose();
    },
    onSubmitSuccess: function onSubmitSuccess(data) {
      optionOverrides.onSubmitSuccess && optionOverrides.onSubmitSuccess(data);
      defaultOptions.onSubmitSuccess && defaultOptions.onSubmitSuccess(data);
    },
    onSubmitError: function onSubmitError(error) {
      optionOverrides.onSubmitError && optionOverrides.onSubmitError(error);
      defaultOptions.onSubmitError && defaultOptions.onSubmitError(error);
    },
    onFormSubmitted: function onFormSubmitted() {
      optionOverrides.onFormSubmitted && optionOverrides.onFormSubmitted();
      defaultOptions.onFormSubmitted && defaultOptions.onFormSubmitted();
    },
    themeDark: _objectSpread(_objectSpread({}, defaultOptions.themeDark), optionOverrides.themeDark),
    themeLight: _objectSpread(_objectSpread({}, defaultOptions.themeLight), optionOverrides.themeLight)
  });
}

/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */
function createActorStyles(styleNonce) {
  var style = DOCUMENT.createElement('style');
  style.textContent = "\n.widget__actor {\n  position: fixed;\n  z-index: var(--z-index);\n  margin: var(--page-margin);\n  inset: var(--actor-inset);\n\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px;\n\n  font-family: inherit;\n  font-size: var(--font-size);\n  font-weight: 600;\n  line-height: 1.14em;\n  text-decoration: none;\n\n  background: var(--actor-background, var(--background));\n  border-radius: var(--actor-border-radius, 1.7em/50%);\n  border: var(--actor-border, var(--border));\n  box-shadow: var(--actor-box-shadow, var(--box-shadow));\n  color: var(--actor-color, var(--foreground));\n  fill: var(--actor-color, var(--foreground));\n  cursor: pointer;\n  opacity: 1;\n  transition: transform 0.2s ease-in-out;\n  transform: translate(0, 0) scale(1);\n}\n.widget__actor[aria-hidden=\"true\"] {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n  transform: translate(0, 16px) scale(0.98);\n}\n\n.widget__actor:hover {\n  background: var(--actor-hover-background, var(--background));\n  filter: var(--interactive-filter);\n}\n\n.widget__actor svg {\n  width: 1.14em;\n  height: 1.14em;\n}\n\n@media (max-width: 600px) {\n  .widget__actor span {\n    display: none;\n  }\n}\n";
  if (styleNonce) {
    style.setAttribute('nonce', styleNonce);
  }
  return style;
}

/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */
function setAttributesNS(el, attributes) {
  Object.entries(attributes).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    el.setAttributeNS(null, key, val);
  });
  return el;
}
var SIZE = 20;
var XMLNS$2 = 'http://www.w3.org/2000/svg';

/**
 * Feedback Icon
 */
function FeedbackIcon() {
  var _setAttributesNS;
  var createElementNS = function createElementNS(tagName) {
    return WINDOW.document.createElementNS(XMLNS$2, tagName);
  };
  var svg = setAttributesNS(createElementNS('svg'), {
    width: "".concat(SIZE),
    height: "".concat(SIZE),
    viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE),
    fill: 'var(--actor-color, var(--foreground))'
  });
  var g = setAttributesNS(createElementNS('g'), {
    clipPath: 'url(#clip0_57_80)'
  });
  var path = setAttributesNS(createElementNS('path'), (_setAttributesNS = {}, _defineProperty(_setAttributesNS, 'fill-rule', 'evenodd'), _defineProperty(_setAttributesNS, 'clip-rule', 'evenodd'), _defineProperty(_setAttributesNS, "d", 'M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z'), _setAttributesNS));
  svg.appendChild(g).appendChild(path);
  var speakerDefs = createElementNS('defs');
  var speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
    id: 'clip0_57_80'
  });
  var speakerRect = setAttributesNS(createElementNS('rect'), {
    width: "".concat(SIZE),
    height: "".concat(SIZE),
    fill: 'white'
  });
  speakerClipPathDef.appendChild(speakerRect);
  speakerDefs.appendChild(speakerClipPathDef);
  svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
  return svg;
}

/**
 * The sentry-provided button to open the feedback modal
 */
function Actor(_ref3) {
  var triggerLabel = _ref3.triggerLabel,
    triggerAriaLabel = _ref3.triggerAriaLabel,
    shadow = _ref3.shadow,
    styleNonce = _ref3.styleNonce;
  var el = DOCUMENT.createElement('button');
  el.type = 'button';
  el.className = 'widget__actor';
  el.ariaHidden = 'false';
  el.ariaLabel = triggerAriaLabel || triggerLabel || TRIGGER_LABEL;
  el.appendChild(FeedbackIcon());
  if (triggerLabel) {
    var label = DOCUMENT.createElement('span');
    label.appendChild(DOCUMENT.createTextNode(triggerLabel));
    el.appendChild(label);
  }
  var style = createActorStyles(styleNonce);
  return {
    el: el,
    appendToDom: function appendToDom() {
      shadow.appendChild(style);
      shadow.appendChild(el);
    },
    removeFromDom: function removeFromDom() {
      shadow.removeChild(el);
      shadow.removeChild(style);
    },
    show: function show() {
      el.ariaHidden = 'false';
    },
    hide: function hide() {
      el.ariaHidden = 'true';
    }
  };
}
var PURPLE = 'rgba(88, 74, 192, 1)';
var DEFAULT_LIGHT = {
  foreground: '#2b2233',
  background: '#ffffff',
  accentForeground: 'white',
  accentBackground: PURPLE,
  successColor: '#268d75',
  errorColor: '#df3338',
  border: '1.5px solid rgba(41, 35, 47, 0.13)',
  boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
  outline: '1px auto var(--accent-background)',
  interactiveFilter: 'brightness(95%)'
};
var DEFAULT_DARK = {
  foreground: '#ebe6ef',
  background: '#29232f',
  accentForeground: 'white',
  accentBackground: PURPLE,
  successColor: '#2da98c',
  errorColor: '#f55459',
  border: '1.5px solid rgba(235, 230, 239, 0.15)',
  boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
  outline: '1px auto var(--accent-background)',
  interactiveFilter: 'brightness(150%)'
};
function getThemedCssVariables(theme) {
  return "\n  --foreground: ".concat(theme.foreground, ";\n  --background: ").concat(theme.background, ";\n  --accent-foreground: ").concat(theme.accentForeground, ";\n  --accent-background: ").concat(theme.accentBackground, ";\n  --success-color: ").concat(theme.successColor, ";\n  --error-color: ").concat(theme.errorColor, ";\n  --border: ").concat(theme.border, ";\n  --box-shadow: ").concat(theme.boxShadow, ";\n  --outline: ").concat(theme.outline, ";\n  --interactive-filter: ").concat(theme.interactiveFilter, ";\n  ");
}

/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */
function createMainStyles(_ref4) {
  var colorScheme = _ref4.colorScheme,
    themeDark = _ref4.themeDark,
    themeLight = _ref4.themeLight,
    styleNonce = _ref4.styleNonce;
  var style = DOCUMENT.createElement('style');
  style.textContent = "\n:host {\n  --font-family: system-ui, 'Helvetica Neue', Arial, sans-serif;\n  --font-size: 14px;\n  --z-index: 100000;\n\n  --page-margin: 16px;\n  --inset: auto 0 0 auto;\n  --actor-inset: var(--inset);\n\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n\n  ".concat(colorScheme !== 'system' ? 'color-scheme: only light;' : '', "\n\n  ").concat(getThemedCssVariables(colorScheme === 'dark' ? _objectSpread(_objectSpread({}, DEFAULT_DARK), themeDark) : _objectSpread(_objectSpread({}, DEFAULT_LIGHT), themeLight)), "\n}\n\n").concat(colorScheme === 'system' ? "\n@media (prefers-color-scheme: dark) {\n  :host {\n    ".concat(getThemedCssVariables(_objectSpread(_objectSpread({}, DEFAULT_DARK), themeDark)), "\n  }\n}") : '', "\n}\n");
  if (styleNonce) {
    style.setAttribute('nonce', styleNonce);
  }
  return style;
}
var buildFeedbackIntegration = function buildFeedbackIntegration(_ref5) {
  var lazyLoadIntegration = _ref5.lazyLoadIntegration,
    getModalIntegration = _ref5.getModalIntegration,
    getScreenshotIntegration = _ref5.getScreenshotIntegration;
  var feedbackIntegration = function feedbackIntegration() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$id = _ref6.id,
      id = _ref6$id === void 0 ? 'sentry-feedback' : _ref6$id,
      _ref6$autoInject = _ref6.autoInject,
      autoInject = _ref6$autoInject === void 0 ? true : _ref6$autoInject,
      _ref6$showBranding = _ref6.showBranding,
      showBranding = _ref6$showBranding === void 0 ? true : _ref6$showBranding,
      _ref6$isEmailRequired = _ref6.isEmailRequired,
      isEmailRequired = _ref6$isEmailRequired === void 0 ? false : _ref6$isEmailRequired,
      _ref6$isNameRequired = _ref6.isNameRequired,
      isNameRequired = _ref6$isNameRequired === void 0 ? false : _ref6$isNameRequired,
      _ref6$showEmail = _ref6.showEmail,
      showEmail = _ref6$showEmail === void 0 ? true : _ref6$showEmail,
      _ref6$showName = _ref6.showName,
      showName = _ref6$showName === void 0 ? true : _ref6$showName,
      _ref6$enableScreensho = _ref6.enableScreenshot,
      enableScreenshot = _ref6$enableScreensho === void 0 ? true : _ref6$enableScreensho,
      _ref6$useSentryUser = _ref6.useSentryUser,
      useSentryUser = _ref6$useSentryUser === void 0 ? {
        email: 'email',
        name: 'username'
      } : _ref6$useSentryUser,
      tags = _ref6.tags,
      styleNonce = _ref6.styleNonce,
      scriptNonce = _ref6.scriptNonce,
      _ref6$colorScheme = _ref6.colorScheme,
      colorScheme = _ref6$colorScheme === void 0 ? 'system' : _ref6$colorScheme,
      _ref6$themeLight = _ref6.themeLight,
      themeLight = _ref6$themeLight === void 0 ? {} : _ref6$themeLight,
      _ref6$themeDark = _ref6.themeDark,
      themeDark = _ref6$themeDark === void 0 ? {} : _ref6$themeDark,
      _ref6$addScreenshotBu = _ref6.addScreenshotButtonLabel,
      addScreenshotButtonLabel = _ref6$addScreenshotBu === void 0 ? ADD_SCREENSHOT_LABEL : _ref6$addScreenshotBu,
      _ref6$cancelButtonLab = _ref6.cancelButtonLabel,
      cancelButtonLabel = _ref6$cancelButtonLab === void 0 ? CANCEL_BUTTON_LABEL : _ref6$cancelButtonLab,
      _ref6$confirmButtonLa = _ref6.confirmButtonLabel,
      confirmButtonLabel = _ref6$confirmButtonLa === void 0 ? CONFIRM_BUTTON_LABEL : _ref6$confirmButtonLa,
      _ref6$emailLabel = _ref6.emailLabel,
      emailLabel = _ref6$emailLabel === void 0 ? EMAIL_LABEL : _ref6$emailLabel,
      _ref6$emailPlaceholde = _ref6.emailPlaceholder,
      emailPlaceholder = _ref6$emailPlaceholde === void 0 ? EMAIL_PLACEHOLDER : _ref6$emailPlaceholde,
      _ref6$formTitle = _ref6.formTitle,
      formTitle = _ref6$formTitle === void 0 ? FORM_TITLE : _ref6$formTitle,
      _ref6$isRequiredLabel = _ref6.isRequiredLabel,
      isRequiredLabel = _ref6$isRequiredLabel === void 0 ? IS_REQUIRED_LABEL : _ref6$isRequiredLabel,
      _ref6$messageLabel = _ref6.messageLabel,
      messageLabel = _ref6$messageLabel === void 0 ? MESSAGE_LABEL : _ref6$messageLabel,
      _ref6$messagePlacehol = _ref6.messagePlaceholder,
      messagePlaceholder = _ref6$messagePlacehol === void 0 ? MESSAGE_PLACEHOLDER : _ref6$messagePlacehol,
      _ref6$nameLabel = _ref6.nameLabel,
      nameLabel = _ref6$nameLabel === void 0 ? NAME_LABEL : _ref6$nameLabel,
      _ref6$namePlaceholder = _ref6.namePlaceholder,
      namePlaceholder = _ref6$namePlaceholder === void 0 ? NAME_PLACEHOLDER : _ref6$namePlaceholder,
      _ref6$removeScreensho = _ref6.removeScreenshotButtonLabel,
      removeScreenshotButtonLabel = _ref6$removeScreensho === void 0 ? REMOVE_SCREENSHOT_LABEL : _ref6$removeScreensho,
      _ref6$submitButtonLab = _ref6.submitButtonLabel,
      submitButtonLabel = _ref6$submitButtonLab === void 0 ? SUBMIT_BUTTON_LABEL : _ref6$submitButtonLab,
      _ref6$successMessageT = _ref6.successMessageText,
      successMessageText = _ref6$successMessageT === void 0 ? SUCCESS_MESSAGE_TEXT : _ref6$successMessageT,
      _ref6$triggerLabel = _ref6.triggerLabel,
      triggerLabel = _ref6$triggerLabel === void 0 ? TRIGGER_LABEL : _ref6$triggerLabel,
      _ref6$triggerAriaLabe = _ref6.triggerAriaLabel,
      triggerAriaLabel = _ref6$triggerAriaLabe === void 0 ? '' : _ref6$triggerAriaLabe,
      onFormOpen = _ref6.onFormOpen,
      onFormClose = _ref6.onFormClose,
      onSubmitSuccess = _ref6.onSubmitSuccess,
      onSubmitError = _ref6.onSubmitError,
      onFormSubmitted = _ref6.onFormSubmitted;
    var _options = {
      id: id,
      autoInject: autoInject,
      showBranding: showBranding,
      isEmailRequired: isEmailRequired,
      isNameRequired: isNameRequired,
      showEmail: showEmail,
      showName: showName,
      enableScreenshot: enableScreenshot,
      useSentryUser: useSentryUser,
      tags: tags,
      styleNonce: styleNonce,
      scriptNonce: scriptNonce,
      colorScheme: colorScheme,
      themeDark: themeDark,
      themeLight: themeLight,
      triggerLabel: triggerLabel,
      triggerAriaLabel: triggerAriaLabel,
      cancelButtonLabel: cancelButtonLabel,
      submitButtonLabel: submitButtonLabel,
      confirmButtonLabel: confirmButtonLabel,
      formTitle: formTitle,
      emailLabel: emailLabel,
      emailPlaceholder: emailPlaceholder,
      messageLabel: messageLabel,
      messagePlaceholder: messagePlaceholder,
      nameLabel: nameLabel,
      namePlaceholder: namePlaceholder,
      successMessageText: successMessageText,
      isRequiredLabel: isRequiredLabel,
      addScreenshotButtonLabel: addScreenshotButtonLabel,
      removeScreenshotButtonLabel: removeScreenshotButtonLabel,
      onFormClose: onFormClose,
      onFormOpen: onFormOpen,
      onSubmitError: onSubmitError,
      onSubmitSuccess: onSubmitSuccess,
      onFormSubmitted: onFormSubmitted
    };
    var _shadow = null;
    var _subscriptions = [];

    /**
     * Get the shadow root where we will append css
     */
    var _createShadow = function _createShadow(options) {
      if (!_shadow) {
        var host = DOCUMENT.createElement('div');
        host.id = String(options.id);
        DOCUMENT.body.appendChild(host);
        _shadow = host.attachShadow({
          mode: 'open'
        });
        _shadow.appendChild(createMainStyles(options));
      }
      return _shadow;
    };
    var _loadAndRenderDialog = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        var screenshotRequired, modalIntegration, screenshotIntegration, modalIntegrationFn, screenshotIntegrationFn, dialog;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              screenshotRequired = options.enableScreenshot && isScreenshotSupported();
              _context.prev = 1;
              if (!getModalIntegration) {
                _context.next = 6;
                break;
              }
              _context.t0 = getModalIntegration();
              _context.next = 9;
              break;
            case 6:
              _context.next = 8;
              return lazyLoadIntegration('feedbackModalIntegration', scriptNonce);
            case 8:
              _context.t0 = _context.sent;
            case 9:
              modalIntegrationFn = _context.t0;
              modalIntegration = modalIntegrationFn();
              addIntegration(modalIntegration);
              _context.next = 18;
              break;
            case 14:
              _context.prev = 14;
              _context.t1 = _context["catch"](1);
              DEBUG_BUILD && logger.error('[Feedback] Error when trying to load feedback integrations. Try using `feedbackSyncIntegration` in your `Sentry.init`.');
              throw new Error('[Feedback] Missing feedback modal integration!');
            case 18:
              _context.prev = 18;
              if (!screenshotRequired) {
                _context.next = 30;
                break;
              }
              if (!getScreenshotIntegration) {
                _context.next = 24;
                break;
              }
              _context.t3 = getScreenshotIntegration();
              _context.next = 27;
              break;
            case 24:
              _context.next = 26;
              return lazyLoadIntegration('feedbackScreenshotIntegration', scriptNonce);
            case 26:
              _context.t3 = _context.sent;
            case 27:
              _context.t2 = _context.t3;
              _context.next = 31;
              break;
            case 30:
              _context.t2 = undefined;
            case 31:
              screenshotIntegrationFn = _context.t2;
              if (screenshotIntegrationFn) {
                screenshotIntegration = screenshotIntegrationFn();
                addIntegration(screenshotIntegration);
              }
              _context.next = 38;
              break;
            case 35:
              _context.prev = 35;
              _context.t4 = _context["catch"](18);
              DEBUG_BUILD && logger.error('[Feedback] Missing feedback screenshot integration. Proceeding without screenshots.');
            case 38:
              dialog = modalIntegration.createDialog({
                options: _objectSpread(_objectSpread({}, options), {}, {
                  onFormClose: function onFormClose() {
                    dialog && dialog.close();
                    options.onFormClose && options.onFormClose();
                  },
                  onFormSubmitted: function onFormSubmitted() {
                    dialog && dialog.close();
                    options.onFormSubmitted && options.onFormSubmitted();
                  }
                }),
                screenshotIntegration: screenshotIntegration,
                sendFeedback: sendFeedback,
                shadow: _createShadow(options)
              });
              return _context.abrupt("return", dialog);
            case 40:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 14], [18, 35]]);
      }));
      return function _loadAndRenderDialog(_x) {
        return _ref7.apply(this, arguments);
      };
    }();
    var _attachTo = function _attachTo(el) {
      var optionOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var mergedOptions = mergeOptions(_options, optionOverrides);
      var targetEl = typeof el === 'string' ? DOCUMENT.querySelector(el) : typeof el.addEventListener === 'function' ? el : null;
      if (!targetEl) {
        DEBUG_BUILD && logger.error('[Feedback] Unable to attach to target element');
        throw new Error('Unable to attach to target element');
      }
      var dialog = null;
      var handleClick = /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (dialog) {
                  _context2.next = 4;
                  break;
                }
                _context2.next = 3;
                return _loadAndRenderDialog(_objectSpread(_objectSpread({}, mergedOptions), {}, {
                  onFormSubmitted: function onFormSubmitted() {
                    dialog && dialog.removeFromDom();
                    mergedOptions.onFormSubmitted && mergedOptions.onFormSubmitted();
                  }
                }));
              case 3:
                dialog = _context2.sent;
              case 4:
                dialog.appendToDom();
                dialog.open();
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function handleClick() {
          return _ref8.apply(this, arguments);
        };
      }();
      targetEl.addEventListener('click', handleClick);
      var unsubscribe = function unsubscribe() {
        _subscriptions = _subscriptions.filter(function (sub) {
          return sub !== unsubscribe;
        });
        dialog && dialog.removeFromDom();
        dialog = null;
        targetEl.removeEventListener('click', handleClick);
      };
      _subscriptions.push(unsubscribe);
      return unsubscribe;
    };
    var _createActor = function _createActor() {
      var optionOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var mergedOptions = mergeOptions(_options, optionOverrides);
      var shadow = _createShadow(mergedOptions);
      var actor = Actor({
        triggerLabel: mergedOptions.triggerLabel,
        triggerAriaLabel: mergedOptions.triggerAriaLabel,
        shadow: shadow,
        styleNonce: styleNonce
      });
      _attachTo(actor.el, _objectSpread(_objectSpread({}, mergedOptions), {}, {
        onFormOpen: function onFormOpen() {
          actor.hide();
        },
        onFormClose: function onFormClose() {
          actor.show();
        },
        onFormSubmitted: function onFormSubmitted() {
          actor.show();
        }
      }));
      return actor;
    };
    return {
      name: 'Feedback',
      setupOnce: function setupOnce() {
        if (!isBrowser() || !_options.autoInject) {
          return;
        }
        if (DOCUMENT.readyState === 'loading') {
          DOCUMENT.addEventListener('DOMContentLoaded', function () {
            return _createActor().appendToDom();
          });
        } else {
          _createActor().appendToDom();
        }
      },
      /**
       * Adds click listener to the element to open a feedback dialog
       *
       * The returned function can be used to remove the click listener
       */
      attachTo: _attachTo,
      /**
       * Creates a new widget which is composed of a Button which triggers a Dialog.
       * Accepts partial options to override any options passed to constructor.
       */
      createWidget: function createWidget() {
        var optionOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var actor = _createActor(mergeOptions(_options, optionOverrides));
        actor.appendToDom();
        return actor;
      },
      /**
       * Creates a new Form which you can
       * Accepts partial options to override any options passed to constructor.
       */
      createForm: function createForm() {
        var _arguments = arguments;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var optionOverrides;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                optionOverrides = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                return _context3.abrupt("return", _loadAndRenderDialog(mergeOptions(_options, optionOverrides)));
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }))();
      },
      /**
       * Removes the Feedback integration (including host, shadow DOM, and all widgets)
       */
      remove: function remove() {
        if (_shadow) {
          _shadow.parentElement && _shadow.parentElement.remove();
          _shadow = null;
        }
        // Remove any lingering subscriptions
        _subscriptions.forEach(function (sub) {
          return sub();
        });
        _subscriptions = [];
      }
    };
  };
  return feedbackIntegration;
};

/**
 * This is a small utility to get a type-safe instance of the Feedback integration.
 */
function getFeedback() {
  var client = getClient();
  return client && client.getIntegrationByName('Feedback');
}
var n,
  l$1,
  u$1,
  i$1,
  o$1,
  r$1,
  f$1,
  c$1 = {},
  s$1 = [],
  a$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
  h$1 = Array.isArray;
function v$1(n, l) {
  for (var u in l) n[u] = l[u];
  return n;
}
function p$1(n) {
  var l = n.parentNode;
  l && l.removeChild(n);
}
function y$1(l, u, t) {
  var i,
    o,
    r,
    f = {};
  for (r in u) "key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
  if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for (r in l.defaultProps) void 0 === f[r] && (f[r] = l.defaultProps[r]);
  return d$1(l, f, i, o, null);
}
function d$1(n, t, i, o, r) {
  var f = {
    type: n,
    props: t,
    key: i,
    ref: o,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    constructor: void 0,
    __v: null == r ? ++u$1 : r,
    __i: -1,
    __u: 0
  };
  return null == r && null != l$1.vnode && l$1.vnode(f), f;
}
function g$1(n) {
  return n.children;
}
function b$1(n, l) {
  this.props = n, this.context = l;
}
function m$1(n, l) {
  if (null == l) return n.__ ? m$1(n.__, n.__i + 1) : null;
  for (var u; l < n.__k.length; l++) if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
  return "function" == typeof n.type ? m$1(n) : null;
}
function w$1(n, u, t) {
  var i,
    o = n.__v,
    r = o.__e,
    f = n.__P;
  if (f) return (i = v$1({}, o)).__v = o.__v + 1, l$1.vnode && l$1.vnode(i), M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [r] : null, u, null == r ? m$1(o) : r, !!(32 & o.__u), t), i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && k$1(i), i;
}
function k$1(n) {
  var l, u;
  if (null != (n = n.__) && null != n.__c) {
    for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) if (null != (u = n.__k[l]) && null != u.__e) {
      n.__e = n.__c.base = u.__e;
      break;
    }
    return k$1(n);
  }
}
function x$1(n) {
  (!n.__d && (n.__d = !0) && i$1.push(n) && !C$1.__r++ || o$1 !== l$1.debounceRendering) && ((o$1 = l$1.debounceRendering) || r$1)(C$1);
}
function C$1() {
  var n,
    u,
    t,
    o = [],
    r = [];
  for (i$1.sort(f$1); n = i$1.shift();) n.__d && (t = i$1.length, u = w$1(n, o, r) || u, 0 === t || i$1.length > t ? (j$1(o, u, r), r.length = o.length = 0, u = void 0, i$1.sort(f$1)) : u && l$1.__c && l$1.__c(u, s$1));
  u && j$1(o, u, r), C$1.__r = 0;
}
function P$1(n, l, u, t, i, o, r, f, e, a, h) {
  var v,
    p,
    y,
    d,
    _,
    g = t && t.__k || s$1,
    b = l.length;
  for (u.__d = e, S(u, l, g), e = u.__d, v = 0; v < b; v++) null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? c$1 : g[y.__i] || c$1, y.__i = v, M(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && N(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
  u.__d = e, u.__e = _;
}
function S(n, l, u) {
  var t,
    i,
    o,
    r,
    f,
    e = l.length,
    c = u.length,
    s = c,
    a = 0;
  for (n.__k = [], t = 0; t < e; t++) null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? d$1(null, i, null, null, i) : h$1(i) ? d$1(g$1, {
    children: i
  }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? d$1(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = I(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && (o.__e == n.__d && (n.__d = m$1(o)), O(o, o, !1), u[t] = null, s--);
  if (s) for (t = 0; t < c; t++) null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = m$1(o)), O(o, o));
}
function $(n, l, u) {
  var t, i;
  if ("function" == typeof n.type) {
    for (t = n.__k, i = 0; t && i < t.length; i++) t[i] && (t[i].__ = n, l = $(t[i], l, u));
    return l;
  }
  n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
  do {
    l = l && l.nextSibling;
  } while (null != l && 8 === l.nodeType);
  return l;
}
function I(n, l, u, t) {
  var i = n.key,
    o = n.type,
    r = u - 1,
    f = u + 1,
    e = l[u];
  if (null === e || e && i == e.key && o === e.type) return u;
  if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for (; r >= 0 || f < l.length;) {
    if (r >= 0) {
      if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
      r--;
    }
    if (f < l.length) {
      if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
      f++;
    }
  }
  return -1;
}
function T$1(n, l, u) {
  "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || a$1.test(l) ? u : u + "px";
}
function A$1(n, l, u, t, i) {
  var o;
  n: if ("style" === l) {
    if ("string" == typeof u) n.style.cssText = u;else {
      if ("string" == typeof t && (n.style.cssText = t = ""), t) for (l in t) u && l in u || T$1(n.style, l, "");
      if (u) for (l in u) t && u[l] === t[l] || T$1(n.style, l, u[l]);
    }
  } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? L : D$1, o)) : n.removeEventListener(l, o ? L : D$1, o);else {
    if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
      n[l] = null == u ? "" : u;
      break n;
    } catch (n) {}
    "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
  }
}
function D$1(n) {
  if (this.l) {
    var u = this.l[n.type + !1];
    if (n.t) {
      if (n.t <= u.u) return;
    } else n.t = Date.now();
    return u(l$1.event ? l$1.event(n) : n);
  }
}
function L(n) {
  if (this.l) return this.l[n.type + !0](l$1.event ? l$1.event(n) : n);
}
function M(n, u, t, i, o, r, f, e, c, s) {
  var a,
    p,
    y,
    d,
    _,
    m,
    w,
    k,
    x,
    C,
    S,
    $,
    H,
    I,
    T,
    A = u.type;
  if (void 0 !== u.constructor) return null;
  128 & t.__u && (c = !!(32 & t.__u), r = [e = u.__e = t.__e]), (a = l$1.__b) && a(u);
  n: if ("function" == typeof A) try {
    if (k = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(k, C) : (u.__c = p = new b$1(k, C), p.constructor = A, p.render = q$1), x && x.sub(p), p.props = k, p.state || (p.state = {}), p.context = C, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = v$1({}, p.__s)), v$1(p.__s, A.getDerivedStateFromProps(k, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);else {
      if (null == A.getDerivedStateFromProps && k !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, C), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, C) || u.__v === t.__v)) {
        for (u.__v !== t.__v && (p.props = k, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function (n) {
          n && (n.__ = u);
        }), S = 0; S < p._sb.length; S++) p.__h.push(p._sb[S]);
        p._sb = [], p.__h.length && f.push(p);
        break n;
      }
      null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, C), null != p.componentDidUpdate && p.__h.push(function () {
        p.componentDidUpdate(d, _, m);
      });
    }
    if (p.context = C, p.props = k, p.__P = n, p.__e = !1, $ = l$1.__r, H = 0, "prototype" in A && A.prototype.render) {
      for (p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++) p.__h.push(p._sb[I]);
      p._sb = [];
    } else do {
      p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
    } while (p.__d && ++H < 25);
    p.state = p.__s, null != p.getChildContext && (i = v$1(v$1({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), P$1(n, h$1(T = null != a && a.type === g$1 && null == a.key ? a.props.children : a) ? T : [T], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), w && (p.__E = p.__ = null);
  } catch (n) {
    u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), l$1.__e(n, u, t);
  } else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = z$1(t.__e, u, t, i, o, r, f, c, s);
  (a = l$1.diffed) && a(u);
}
function j$1(n, u, t) {
  for (var i = 0; i < t.length; i++) N(t[i], t[++i], t[++i]);
  l$1.__c && l$1.__c(u, n), n.some(function (u) {
    try {
      n = u.__h, u.__h = [], n.some(function (n) {
        n.call(u);
      });
    } catch (n) {
      l$1.__e(n, u.__v);
    }
  });
}
function z$1(l, u, t, i, o, r, f, e, s) {
  var a,
    v,
    y,
    d,
    _,
    g,
    b,
    w = t.props,
    k = u.props,
    x = u.type;
  if ("svg" === x && (o = !0), null != r) for (a = 0; a < r.length; a++) if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
    l = _, r[a] = null;
    break;
  }
  if (null == l) {
    if (null === x) return document.createTextNode(k);
    l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, k.is && k), r = null, e = !1;
  }
  if (null === x) w === k || e && l.data === k || (l.data = k);else {
    if (r = r && n.call(l.childNodes), w = t.props || c$1, !e && null != r) for (w = {}, a = 0; a < l.attributes.length; a++) w[(_ = l.attributes[a]).name] = _.value;
    for (a in w) _ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in k || A$1(l, a, null, _, o));
    for (a in k) _ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || w[a] === _ || A$1(l, a, _, w[a], o);
    if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];else if (y && (l.innerHTML = ""), P$1(l, h$1(d) ? d : [d], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && m$1(t, 0), e, s), null != r) for (a = r.length; a--;) null != r[a] && p$1(r[a]);
    e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== w[a]) && A$1(l, a, g, w[a], !1), a = "checked", void 0 !== b && b !== l[a] && A$1(l, a, b, w[a], !1));
  }
  return l;
}
function N(n, u, t) {
  try {
    "function" == typeof n ? n(u) : n.current = u;
  } catch (n) {
    l$1.__e(n, t);
  }
}
function O(n, u, t) {
  var i, o;
  if (l$1.unmount && l$1.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || N(i, null, u)), null != (i = n.__c)) {
    if (i.componentWillUnmount) try {
      i.componentWillUnmount();
    } catch (n) {
      l$1.__e(n, u);
    }
    i.base = i.__P = null, n.__c = void 0;
  }
  if (i = n.__k) for (o = 0; o < i.length; o++) i[o] && O(i[o], u, t || "function" != typeof n.type);
  t || null == n.__e || p$1(n.__e), n.__ = n.__e = n.__d = void 0;
}
function q$1(n, l, u) {
  return this.constructor(n, u);
}
function B$1(u, t, i) {
  var o, r, f, e;
  l$1.__ && l$1.__(u, t), r = (o = "function" == typeof i) ? null : t.__k, f = [], e = [], M(t, u = (!o && i || t).__k = y$1(g$1, null, [u]), r || c$1, c$1, void 0 !== t.ownerSVGElement, !o && i ? [i] : r ? null : t.firstChild ? n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), u.__d = void 0, j$1(f, u, e);
}
n = s$1.slice, l$1 = {
  __e: function __e(n, l, u, t) {
    for (var i, o, r; l = l.__;) if ((i = l.__c) && !i.__) try {
      if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
    } catch (l) {
      n = l;
    }
    throw n;
  }
}, u$1 = 0, b$1.prototype.setState = function (n, l) {
  var u;
  u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = v$1({}, this.state), "function" == typeof n && (n = n(v$1({}, u), this.props)), n && v$1(u, n), null != n && this.__v && (l && this._sb.push(l), x$1(this));
}, b$1.prototype.forceUpdate = function (n) {
  this.__v && (this.__e = !0, n && this.__h.push(n), x$1(this));
}, b$1.prototype.render = g$1, i$1 = [], r$1 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$1 = function f$1(n, l) {
  return n.__v.__b - l.__v.__b;
}, C$1.__r = 0;
var t,
  r,
  u,
  i,
  o = 0,
  f = [],
  c = [],
  e = l$1,
  a = e.__b,
  v = e.__r,
  l = e.diffed,
  m = e.__c,
  s = e.unmount,
  d = e.__;
function h(n, t) {
  e.__h && e.__h(r, n, o || t), o = 0;
  var u = r.__H || (r.__H = {
    __: [],
    __h: []
  });
  return n >= u.__.length && u.__.push({
    __V: c
  }), u.__[n];
}
function p(n) {
  return o = 1, y(D, n);
}
function y(n, u, i) {
  var o = h(t++, 2);
  if (o.t = n, !o.__c && (o.__ = [i ? i(u) : D(void 0, u), function (n) {
    var t = o.__N ? o.__N[0] : o.__[0],
      r = o.t(t, n);
    t !== r && (o.__N = [r, o.__[1]], o.__c.setState({}));
  }], o.__c = r, !r.u)) {
    var f = function f(n, t, r) {
      if (!o.__c.__H) return !0;
      var u = o.__c.__H.__.filter(function (n) {
        return !!n.__c;
      });
      if (u.every(function (n) {
        return !n.__N;
      })) return !c || c.call(this, n, t, r);
      var i = !1;
      return u.forEach(function (n) {
        if (n.__N) {
          var t = n.__[0];
          n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
        }
      }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
    };
    r.u = !0;
    var c = r.shouldComponentUpdate,
      e = r.componentWillUpdate;
    r.componentWillUpdate = function (n, t, r) {
      if (this.__e) {
        var u = c;
        c = void 0, f(n, t, r), c = u;
      }
      e && e.call(this, n, t, r);
    }, r.shouldComponentUpdate = f;
  }
  return o.__N || o.__;
}
function _(n, u) {
  var i = h(t++, 3);
  !e.__s && C(i.__H, u) && (i.__ = n, i.i = u, r.__H.__h.push(i));
}
function A(n, u) {
  var i = h(t++, 4);
  !e.__s && C(i.__H, u) && (i.__ = n, i.i = u, r.__h.push(i));
}
function F(n) {
  return o = 5, q(function () {
    return {
      current: n
    };
  }, []);
}
function T(n, t, r) {
  o = 6, A(function () {
    return "function" == typeof n ? (n(t()), function () {
      return n(null);
    }) : n ? (n.current = t(), function () {
      return n.current = null;
    }) : void 0;
  }, null == r ? r : r.concat(n));
}
function q(n, r) {
  var u = h(t++, 7);
  return C(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function x(n, t) {
  return o = 8, q(function () {
    return n;
  }, t);
}
function P(n) {
  var u = r.context[n.__c],
    i = h(t++, 9);
  return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub(r)), u.props.value) : n.__;
}
function V(n, t) {
  e.useDebugValue && e.useDebugValue(t ? t(n) : n);
}
function b(n) {
  var u = h(t++, 10),
    i = p();
  return u.__ = n, r.componentDidCatch || (r.componentDidCatch = function (n, t) {
    u.__ && u.__(n, t), i[1](n);
  }), [i[0], function () {
    i[1](void 0);
  }];
}
function g() {
  var n = h(t++, 11);
  if (!n.__) {
    for (var u = r.__v; null !== u && !u.__m && null !== u.__;) u = u.__;
    var i = u.__m || (u.__m = [0, 0]);
    n.__ = "P" + i[0] + "-" + i[1]++;
  }
  return n.__;
}
function j() {
  for (var n; n = f.shift();) if (n.__P && n.__H) try {
    n.__H.__h.forEach(z), n.__H.__h.forEach(B), n.__H.__h = [];
  } catch (t) {
    n.__H.__h = [], e.__e(t, n.__v);
  }
}
e.__b = function (n) {
  r = null, a && a(n);
}, e.__ = function (n, t) {
  t.__k && t.__k.__m && (n.__m = t.__k.__m), d && d(n, t);
}, e.__r = function (n) {
  v && v(n), t = 0;
  var i = (r = n.__c).__H;
  i && (u === r ? (i.__h = [], r.__h = [], i.__.forEach(function (n) {
    n.__N && (n.__ = n.__N), n.__V = c, n.__N = n.i = void 0;
  })) : (i.__h.forEach(z), i.__h.forEach(B), i.__h = [], t = 0)), u = r;
}, e.diffed = function (n) {
  l && l(n);
  var t = n.__c;
  t && t.__H && (t.__H.__h.length && (1 !== f.push(t) && i === e.requestAnimationFrame || ((i = e.requestAnimationFrame) || w)(j)), t.__H.__.forEach(function (n) {
    n.i && (n.__H = n.i), n.__V !== c && (n.__ = n.__V), n.i = void 0, n.__V = c;
  })), u = r = null;
}, e.__c = function (n, t) {
  t.some(function (n) {
    try {
      n.__h.forEach(z), n.__h = n.__h.filter(function (n) {
        return !n.__ || B(n);
      });
    } catch (r) {
      t.some(function (n) {
        n.__h && (n.__h = []);
      }), t = [], e.__e(r, n.__v);
    }
  }), m && m(n, t);
}, e.unmount = function (n) {
  s && s(n);
  var t,
    r = n.__c;
  r && r.__H && (r.__H.__.forEach(function (n) {
    try {
      z(n);
    } catch (n) {
      t = n;
    }
  }), r.__H = void 0, t && e.__e(t, r.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n) {
  var t,
    r = function r() {
      clearTimeout(u), k && cancelAnimationFrame(t), setTimeout(n);
    },
    u = setTimeout(r, 100);
  k && (t = requestAnimationFrame(r));
}
function z(n) {
  var t = r,
    u = n.__c;
  "function" == typeof u && (n.__c = void 0, u()), r = t;
}
function B(n) {
  var t = r;
  n.__c = n.__(), r = t;
}
function C(n, t) {
  return !n || n.length !== t.length || t.some(function (t, r) {
    return t !== n[r];
  });
}
function D(n, t) {
  return "function" == typeof t ? t(n) : t;
}
var hooks = {
  __proto__: null,
  useCallback: x,
  useContext: P,
  useDebugValue: V,
  useEffect: _,
  useErrorBoundary: b,
  useId: g,
  useImperativeHandle: T,
  useLayoutEffect: A,
  useMemo: q,
  useReducer: y,
  useRef: F,
  useState: p
};
var XMLNS$1 = 'http://www.w3.org/2000/svg';

/**
 * Sentry Logo
 */
function SentryLogo() {
  var createElementNS = function createElementNS(tagName) {
    return DOCUMENT.createElementNS(XMLNS$1, tagName);
  };
  var svg = setAttributesNS(createElementNS('svg'), {
    width: '32',
    height: '30',
    viewBox: '0 0 72 66',
    fill: 'inherit'
  });
  var path = setAttributesNS(createElementNS('path'), {
    transform: 'translate(11, 11)',
    d: 'M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z'
  });
  svg.appendChild(path);
  return svg;
}
function DialogHeader(_ref9) {
  var options = _ref9.options;
  var logoHtml = q(function () {
    return {
      __html: SentryLogo().outerHTML
    };
  }, []);
  return y$1('h2', {
    class: "dialog__header"
  }, y$1('span', {
    class: "dialog__title"
  }, options.formTitle), options.showBranding ? y$1('a', {
    class: "brand-link",
    target: "_blank",
    href: "https://sentry.io/welcome/",
    title: "Powered by Sentry",
    rel: "noopener noreferrer",
    dangerouslySetInnerHTML: logoHtml
  }) : null);
}

/**
 * Validate that a given feedback submission has the required fields
 */
function getMissingFields(feedback, props) {
  var emptyFields = [];
  if (props.isNameRequired && !feedback.name) {
    emptyFields.push(props.nameLabel);
  }
  if (props.isEmailRequired && !feedback.email) {
    emptyFields.push(props.emailLabel);
  }
  if (!feedback.message) {
    emptyFields.push(props.messageLabel);
  }
  return emptyFields;
}
function retrieveStringValue(formData, key) {
  var value = formData.get(key);
  if (typeof value === 'string') {
    return value.trim();
  }
  return '';
}
function Form(_ref10) {
  var options = _ref10.options,
    defaultEmail = _ref10.defaultEmail,
    defaultName = _ref10.defaultName,
    onFormClose = _ref10.onFormClose,
    onSubmit = _ref10.onSubmit,
    onSubmitSuccess = _ref10.onSubmitSuccess,
    onSubmitError = _ref10.onSubmitError,
    showEmail = _ref10.showEmail,
    showName = _ref10.showName,
    screenshotInput = _ref10.screenshotInput;
  var tags = options.tags,
    addScreenshotButtonLabel = options.addScreenshotButtonLabel,
    removeScreenshotButtonLabel = options.removeScreenshotButtonLabel,
    cancelButtonLabel = options.cancelButtonLabel,
    emailLabel = options.emailLabel,
    emailPlaceholder = options.emailPlaceholder,
    isEmailRequired = options.isEmailRequired,
    isNameRequired = options.isNameRequired,
    messageLabel = options.messageLabel,
    messagePlaceholder = options.messagePlaceholder,
    nameLabel = options.nameLabel,
    namePlaceholder = options.namePlaceholder,
    submitButtonLabel = options.submitButtonLabel,
    isRequiredLabel = options.isRequiredLabel;
  // TODO: set a ref on the form, and whenever an input changes call processForm() and setError()
  var _p = p(null),
    _p2 = _slicedToArray(_p, 2),
    error = _p2[0],
    setError = _p2[1];
  var _p3 = p(false),
    _p4 = _slicedToArray(_p3, 2),
    showScreenshotInput = _p4[0],
    setShowScreenshotInput = _p4[1];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var ScreenshotInputComponent = screenshotInput && screenshotInput.input;
  var _p5 = p(null),
    _p6 = _slicedToArray(_p5, 2),
    screenshotError = _p6[0],
    setScreenshotError = _p6[1];
  var onScreenshotError = x(function (error) {
    setScreenshotError(error);
    setShowScreenshotInput(false);
  }, []);
  var hasAllRequiredFields = x(function (data) {
    var missingFields = getMissingFields(data, {
      emailLabel: emailLabel,
      isEmailRequired: isEmailRequired,
      isNameRequired: isNameRequired,
      messageLabel: messageLabel,
      nameLabel: nameLabel
    });
    if (missingFields.length > 0) {
      setError("Please enter in the following required fields: ".concat(missingFields.join(', ')));
    } else {
      setError(null);
    }
    return missingFields.length === 0;
  }, [emailLabel, isEmailRequired, isNameRequired, messageLabel, nameLabel]);
  var handleSubmit = x( /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
      var formData, attachment, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            e.preventDefault();
            if (e.target instanceof HTMLFormElement) {
              _context4.next = 4;
              break;
            }
            return _context4.abrupt("return");
          case 4:
            formData = new FormData(e.target);
            _context4.next = 7;
            return screenshotInput && showScreenshotInput ? screenshotInput.value() : undefined;
          case 7:
            attachment = _context4.sent;
            data = {
              name: retrieveStringValue(formData, 'name'),
              email: retrieveStringValue(formData, 'email'),
              message: retrieveStringValue(formData, 'message'),
              attachments: attachment ? [attachment] : undefined
            };
            if (hasAllRequiredFields(data)) {
              _context4.next = 11;
              break;
            }
            return _context4.abrupt("return");
          case 11:
            _context4.prev = 11;
            _context4.next = 14;
            return onSubmit({
              name: data.name,
              email: data.email,
              message: data.message,
              source: FEEDBACK_WIDGET_SOURCE,
              tags: tags
            }, {
              attachments: data.attachments
            });
          case 14:
            onSubmitSuccess(data);
            _context4.next = 22;
            break;
          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](11);
            DEBUG_BUILD && logger.error(_context4.t0);
            setError(_context4.t0);
            onSubmitError(_context4.t0);
          case 22:
            _context4.next = 26;
            break;
          case 24:
            _context4.prev = 24;
            _context4.t1 = _context4["catch"](0);
          case 26:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 24], [11, 17]]);
    }));
    return function (_x2) {
      return _ref11.apply(this, arguments);
    };
  }(), [screenshotInput && showScreenshotInput, onSubmitSuccess, onSubmitError]);
  return y$1('form', {
    class: "form",
    onSubmit: handleSubmit
  }, ScreenshotInputComponent && showScreenshotInput ? y$1(ScreenshotInputComponent, {
    onError: onScreenshotError
  }) : null, y$1('div', {
    class: "form__right",
    'data-sentry-feedback': true
  }, y$1('div', {
    class: "form__top"
  }, error ? y$1('div', {
    class: "form__error-container"
  }, error) : null, showName ? y$1('label', {
    for: "name",
    class: "form__label"
  }, y$1(LabelText, {
    label: nameLabel,
    isRequiredLabel: isRequiredLabel,
    isRequired: isNameRequired
  }), y$1('input', {
    class: "form__input",
    defaultValue: defaultName,
    id: "name",
    name: "name",
    placeholder: namePlaceholder,
    required: isNameRequired,
    type: "text"
  })) : y$1('input', {
    'aria-hidden': true,
    value: defaultName,
    name: "name",
    type: "hidden"
  }), showEmail ? y$1('label', {
    for: "email",
    class: "form__label"
  }, y$1(LabelText, {
    label: emailLabel,
    isRequiredLabel: isRequiredLabel,
    isRequired: isEmailRequired
  }), y$1('input', {
    class: "form__input",
    defaultValue: defaultEmail,
    id: "email",
    name: "email",
    placeholder: emailPlaceholder,
    required: isEmailRequired,
    type: "email"
  })) : y$1('input', {
    'aria-hidden': true,
    value: defaultEmail,
    name: "email",
    type: "hidden"
  }), y$1('label', {
    for: "message",
    class: "form__label"
  }, y$1(LabelText, {
    label: messageLabel,
    isRequiredLabel: isRequiredLabel,
    isRequired: true
  }), y$1('textarea', {
    autoFocus: true,
    class: "form__input form__input--textarea",
    id: "message",
    name: "message",
    placeholder: messagePlaceholder,
    required: true,
    rows: 5
  })), ScreenshotInputComponent ? y$1('label', {
    for: "screenshot",
    class: "form__label"
  }, y$1('button', {
    class: "btn btn--default",
    type: "button",
    onClick: function onClick() {
      setScreenshotError(null);
      setShowScreenshotInput(function (prev) {
        return !prev;
      });
    }
  }, showScreenshotInput ? removeScreenshotButtonLabel : addScreenshotButtonLabel), screenshotError ? y$1('div', {
    class: "form__error-container"
  }, screenshotError.message) : null) : null), y$1('div', {
    class: "btn-group"
  }, y$1('button', {
    class: "btn btn--primary",
    type: "submit"
  }, submitButtonLabel), y$1('button', {
    class: "btn btn--default",
    type: "button",
    onClick: onFormClose
  }, cancelButtonLabel))));
}
function LabelText(_ref12) {
  var label = _ref12.label,
    isRequired = _ref12.isRequired,
    isRequiredLabel = _ref12.isRequiredLabel;
  return y$1('span', {
    class: "form__label__text"
  }, label, isRequired && y$1('span', {
    class: "form__label__text--required"
  }, isRequiredLabel));
}
var WIDTH = 16;
var HEIGHT = 17;
var XMLNS = 'http://www.w3.org/2000/svg';

/**
 * Success Icon (checkmark)
 */
function SuccessIcon() {
  var _setAttributesNS2;
  var createElementNS = function createElementNS(tagName) {
    return WINDOW.document.createElementNS(XMLNS, tagName);
  };
  var svg = setAttributesNS(createElementNS('svg'), {
    width: "".concat(WIDTH),
    height: "".concat(HEIGHT),
    viewBox: "0 0 ".concat(WIDTH, " ").concat(HEIGHT),
    fill: 'inherit'
  });
  var g = setAttributesNS(createElementNS('g'), {
    clipPath: 'url(#clip0_57_156)'
  });
  var path2 = setAttributesNS(createElementNS('path'), (_setAttributesNS2 = {}, _defineProperty(_setAttributesNS2, 'fill-rule', 'evenodd'), _defineProperty(_setAttributesNS2, 'clip-rule', 'evenodd'), _defineProperty(_setAttributesNS2, "d", 'M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z'), _setAttributesNS2));
  var path = setAttributesNS(createElementNS('path'), {
    d: 'M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z'
  });
  svg.appendChild(g).append(path, path2);
  var speakerDefs = createElementNS('defs');
  var speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
    id: 'clip0_57_156'
  });
  var speakerRect = setAttributesNS(createElementNS('rect'), {
    width: "".concat(WIDTH),
    height: "".concat(WIDTH),
    fill: 'white',
    transform: 'translate(0 0.5)'
  });
  speakerClipPathDef.appendChild(speakerRect);
  speakerDefs.appendChild(speakerClipPathDef);
  svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
  return svg;
}
function Dialog(_ref13) {
  var open = _ref13.open,
    onFormSubmitted = _ref13.onFormSubmitted,
    props = _objectWithoutProperties(_ref13, _excluded);
  var options = props.options;
  var successIconHtml = q(function () {
    return {
      __html: SuccessIcon().outerHTML
    };
  }, []);
  var _p7 = p(null),
    _p8 = _slicedToArray(_p7, 2),
    timeoutId = _p8[0],
    setTimeoutId = _p8[1];
  var handleOnSuccessClick = x(function () {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    onFormSubmitted();
  }, [timeoutId]);
  var onSubmitSuccess = x(function (data) {
    props.onSubmitSuccess(data);
    setTimeoutId(setTimeout(function () {
      onFormSubmitted();
      setTimeoutId(null);
    }, SUCCESS_MESSAGE_TIMEOUT));
  }, [onFormSubmitted]);
  return y$1(g$1, null, timeoutId ? y$1('div', {
    class: "success__position",
    onClick: handleOnSuccessClick
  }, y$1('div', {
    class: "success__content"
  }, options.successMessageText, y$1('span', {
    class: "success__icon",
    dangerouslySetInnerHTML: successIconHtml
  }))) : y$1('dialog', {
    class: "dialog",
    onClick: options.onFormClose,
    open: open
  }, y$1('div', {
    class: "dialog__position"
  }, y$1('div', {
    class: "dialog__content",
    onClick: function onClick(e) {
      // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
      e.stopPropagation();
    }
  }, y$1(DialogHeader, {
    options: options
  }), y$1(Form, _objectSpread(_objectSpread({}, props), {}, {
    onSubmitSuccess: onSubmitSuccess
  }))))));
}
var DIALOG = "\n.dialog {\n  position: fixed;\n  z-index: var(--z-index);\n  margin: 0;\n  inset: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  height: 100vh;\n  width: 100vw;\n\n  color: var(--dialog-color, var(--foreground));\n  fill: var(--dialog-color, var(--foreground));\n  line-height: 1.75em;\n\n  background-color: rgba(0, 0, 0, 0.05);\n  border: none;\n  inset: 0;\n  opacity: 1;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.dialog__position {\n  position: fixed;\n  z-index: var(--z-index);\n  inset: var(--dialog-inset);\n  padding: var(--page-margin);\n  display: flex;\n  max-height: calc(100vh - (2 * var(--page-margin)));\n}\n@media (max-width: 600px) {\n  .dialog__position {\n    inset: var(--page-margin);\n    padding: 0;\n  }\n}\n\n.dialog__position:has(.editor) {\n  inset: var(--page-margin);\n  padding: 0;\n}\n\n.dialog:not([open]) {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n.dialog:not([open]) .dialog__content {\n  transform: translate(0, -16px) scale(0.98);\n}\n\n.dialog__content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: var(--dialog-padding, 24px);\n  max-width: 100%;\n  width: 100%;\n  max-height: 100%;\n  overflow: auto;\n\n  background: var(--dialog-background, var(--background));\n  border-radius: var(--dialog-border-radius, 20px);\n  border: var(--dialog-border, var(--border));\n  box-shadow: var(--dialog-box-shadow, var(--box-shadow));\n  transform: translate(0, 0) scale(1);\n  transition: transform 0.2s ease-in-out;\n}\n\n";
var DIALOG_HEADER = "\n.dialog__header {\n  display: flex;\n  gap: 4px;\n  justify-content: space-between;\n  font-weight: var(--dialog-header-weight, 600);\n  margin: 0;\n}\n.dialog__title {\n  align-self: center;\n  width: var(--form-width, 272px);\n}\n\n@media (max-width: 600px) {\n  .dialog__title {\n    width: auto;\n  }\n}\n\n.dialog__position:has(.editor) .dialog__title {\n  width: auto;\n}\n\n\n.brand-link {\n  display: inline-flex;\n}\n.brand-link:focus-visible {\n  outline: var(--outline);\n}\n";
var FORM = "\n.form {\n  display: flex;\n  overflow: auto;\n  flex-direction: row;\n  gap: 16px;\n  flex: 1 0;\n}\n\n.form__right {\n  flex: 0 0 auto;\n  display: flex;\n  overflow: auto;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 20px;\n  width: var(--form-width, 100%);\n}\n\n.dialog__position:has(.editor) .form__right {\n  width: var(--form-width, 272px);\n}\n\n.form__top {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form__error-container {\n  color: var(--error-color);\n  fill: var(--error-color);\n}\n\n.form__label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0px;\n}\n\n.form__label__text {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.form__label__text--required {\n  font-size: 0.85em;\n}\n\n.form__input {\n  font-family: inherit;\n  line-height: inherit;\n  background: transparent;\n  box-sizing: border-box;\n  border: var(--input-border, var(--border));\n  border-radius: var(--input-border-radius, 6px);\n  color: var(--input-color, inherit);\n  fill: var(--input-color, inherit);\n  font-size: var(--input-font-size, inherit);\n  font-weight: var(--input-font-weight, 500);\n  padding: 6px 12px;\n}\n\n.form__input::placeholder {\n  opacity: 0.65;\n  color: var(--input-placeholder-color, inherit);\n  filter: var(--interactive-filter);\n}\n\n.form__input:focus-visible {\n  outline: var(--input-focus-outline, var(--outline));\n}\n\n.form__input--textarea {\n  font-family: inherit;\n  resize: vertical;\n}\n\n.error {\n  color: var(--error-color);\n  fill: var(--error-color);\n}\n";
var BUTTON = "\n.btn-group {\n  display: grid;\n  gap: 8px;\n}\n\n.btn {\n  line-height: inherit;\n  border: var(--button-border, var(--border));\n  border-radius: var(--button-border-radius, 6px);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--button-font-size, inherit);\n  font-weight: var(--button-font-weight, 600);\n  padding: var(--button-padding, 6px 16px);\n}\n.btn[disabled] {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.btn--primary {\n  color: var(--button-primary-color, var(--accent-foreground));\n  fill: var(--button-primary-color, var(--accent-foreground));\n  background: var(--button-primary-background, var(--accent-background));\n  border: var(--button-primary-border, var(--border));\n  border-radius: var(--button-primary-border-radius, 6px);\n  font-weight: var(--button-primary-font-weight, 500);\n}\n.btn--primary:hover {\n  color: var(--button-primary-hover-color, var(--accent-foreground));\n  fill: var(--button-primary-hover-color, var(--accent-foreground));\n  background: var(--button-primary-hover-background, var(--accent-background));\n  filter: var(--interactive-filter);\n}\n.btn--primary:focus-visible {\n  background: var(--button-primary-hover-background, var(--accent-background));\n  filter: var(--interactive-filter);\n  outline: var(--button-primary-focus-outline, var(--outline));\n}\n\n.btn--default {\n  color: var(--button-color, var(--foreground));\n  fill: var(--button-color, var(--foreground));\n  background: var(--button-background, var(--background));\n  border: var(--button-border, var(--border));\n  border-radius: var(--button-border-radius, 6px);\n  font-weight: var(--button-font-weight, 500);\n}\n.btn--default:hover {\n  color: var(--button-color, var(--foreground));\n  fill: var(--button-color, var(--foreground));\n  background: var(--button-hover-background, var(--background));\n  filter: var(--interactive-filter);\n}\n.btn--default:focus-visible {\n  background: var(--button-hover-background, var(--background));\n  filter: var(--interactive-filter);\n  outline: var(--button-focus-outline, var(--outline));\n}\n";
var SUCCESS = "\n.success__position {\n  position: fixed;\n  inset: var(--dialog-inset);\n  padding: var(--page-margin);\n  z-index: var(--z-index);\n}\n.success__content {\n  background: var(--success-background, var(--background));\n  border: var(--success-border, var(--border));\n  border-radius: var(--success-border-radius, 1.7em/50%);\n  box-shadow: var(--success-box-shadow, var(--box-shadow));\n  font-weight: var(--success-font-weight, 600);\n  color: var(--success-color);\n  fill: var(--success-color);\n  padding: 12px 24px;\n  line-height: 1.75em;\n\n  display: grid;\n  align-items: center;\n  grid-auto-flow: column;\n  gap: 6px;\n  cursor: default;\n}\n\n.success__icon {\n  display: flex;\n}\n";

/**
 * Creates <style> element for widget dialog
 */
function createDialogStyles(styleNonce) {
  var style = DOCUMENT.createElement('style');
  style.textContent = "\n:host {\n  --dialog-inset: var(--inset);\n}\n\n".concat(DIALOG, "\n").concat(DIALOG_HEADER, "\n").concat(FORM, "\n").concat(BUTTON, "\n").concat(SUCCESS, "\n");
  if (styleNonce) {
    style.setAttribute('nonce', styleNonce);
  }
  return style;
}
function getUser() {
  var currentUser = getCurrentScope().getUser();
  var isolationUser = getIsolationScope().getUser();
  var globalUser = getGlobalScope().getUser();
  if (currentUser && Object.keys(currentUser).length) {
    return currentUser;
  }
  if (isolationUser && Object.keys(isolationUser).length) {
    return isolationUser;
  }
  return globalUser;
}
var feedbackModalIntegration = function feedbackModalIntegration() {
  return {
    name: 'FeedbackModal',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setupOnce: function setupOnce() {},
    createDialog: function createDialog(_ref14) {
      var options = _ref14.options,
        screenshotIntegration = _ref14.screenshotIntegration,
        sendFeedback = _ref14.sendFeedback,
        shadow = _ref14.shadow;
      var shadowRoot = shadow;
      var userKey = options.useSentryUser;
      var user = getUser();
      var el = DOCUMENT.createElement('div');
      var style = createDialogStyles(options.styleNonce);
      var originalOverflow = '';
      var dialog = {
        get el() {
          return el;
        },
        appendToDom: function appendToDom() {
          if (!shadowRoot.contains(style) && !shadowRoot.contains(el)) {
            shadowRoot.appendChild(style);
            shadowRoot.appendChild(el);
          }
        },
        removeFromDom: function removeFromDom() {
          shadowRoot.removeChild(el);
          shadowRoot.removeChild(style);
          DOCUMENT.body.style.overflow = originalOverflow;
        },
        open: function open() {
          renderContent(true);
          options.onFormOpen && options.onFormOpen();
          originalOverflow = DOCUMENT.body.style.overflow;
          DOCUMENT.body.style.overflow = 'hidden';
        },
        close: function close() {
          renderContent(false);
          DOCUMENT.body.style.overflow = originalOverflow;
        }
      };
      var screenshotInput = screenshotIntegration && screenshotIntegration.createInput({
        h: y$1,
        hooks: hooks,
        dialog: dialog,
        options: options
      });
      var renderContent = function renderContent(open) {
        B$1(y$1(Dialog, {
          options: options,
          screenshotInput: screenshotInput,
          showName: options.showName || options.isNameRequired,
          showEmail: options.showEmail || options.isEmailRequired,
          defaultName: userKey && user && user[userKey.name] || '',
          defaultEmail: userKey && user && user[userKey.email] || '',
          onFormClose: function onFormClose() {
            renderContent(false);
            options.onFormClose && options.onFormClose();
          },
          onSubmit: sendFeedback,
          onSubmitSuccess: function onSubmitSuccess(data) {
            renderContent(false);
            options.onSubmitSuccess && options.onSubmitSuccess(data);
          },
          onSubmitError: function onSubmitError(error) {
            options.onSubmitError && options.onSubmitError(error);
          },
          onFormSubmitted: function onFormSubmitted() {
            options.onFormSubmitted && options.onFormSubmitted();
          },
          open: open
        }), el);
      };
      return dialog;
    }
  };
};
function CropCornerFactory(_ref15) {
  var h = _ref15.h;
  return function CropCorner(_ref16) {
    var top = _ref16.top,
      left = _ref16.left,
      corner = _ref16.corner,
      onGrabButton = _ref16.onGrabButton;
    return h('button', {
      class: "editor__crop-corner editor__crop-corner--".concat(corner, " "),
      style: {
        top: top,
        left: left
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        onGrabButton(e, corner);
      },
      onClick: function onClick(e) {
        e.preventDefault();
      }
    });
  };
}

/**
 * Creates <style> element for widget dialog
 */
function createScreenshotInputStyles(styleNonce) {
  var style = DOCUMENT.createElement('style');
  var surface200 = '#1A141F';
  var gray100 = '#302735';
  style.textContent = "\n.editor {\n  padding: 10px;\n  padding-top: 65px;\n  padding-bottom: 65px;\n  flex-grow: 1;\n\n  background-color: ".concat(surface200, ";\n  background-image: repeating-linear-gradient(\n      -145deg,\n      transparent,\n      transparent 8px,\n      ").concat(surface200, " 8px,\n      ").concat(surface200, " 11px\n    ),\n    repeating-linear-gradient(\n      -45deg,\n      transparent,\n      transparent 15px,\n      ").concat(gray100, " 15px,\n      ").concat(gray100, " 16px\n    );\n}\n\n.editor__canvas-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.editor__canvas-container canvas {\n  object-fit: contain;\n  position: relative;\n}\n\n.editor__crop-btn-group {\n  padding: 8px;\n  gap: 8px;\n  border-radius: var(--menu-border-radius, 6px);\n  background: var(--button-primary-background, var(--background));\n  width: 175px;\n  position: absolute;\n}\n\n.editor__crop-corner {\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  background: none;\n  border: 3px solid #ffffff;\n}\n\n.editor__crop-corner--top-left {\n  cursor: nwse-resize;\n  border-right: none;\n  border-bottom: none;\n}\n.editor__crop-corner--top-right {\n  cursor: nesw-resize;\n  border-left: none;\n  border-bottom: none;\n}\n.editor__crop-corner--bottom-left {\n  cursor: nesw-resize;\n  border-right: none;\n  border-top: none;\n}\n.editor__crop-corner--bottom-right {\n  cursor: nwse-resize;\n  border-left: none;\n  border-top: none;\n}\n");
  if (styleNonce) {
    style.setAttribute('nonce', styleNonce);
  }
  return style;
}
function useTakeScreenshotFactory(_ref17) {
  var hooks = _ref17.hooks;
  return function useTakeScreenshot(_ref18) {
    var onBeforeScreenshot = _ref18.onBeforeScreenshot,
      onScreenshot = _ref18.onScreenshot,
      onAfterScreenshot = _ref18.onAfterScreenshot,
      onError = _ref18.onError;
    hooks.useEffect(function () {
      var takeScreenshot = /*#__PURE__*/function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
          var stream, video;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                onBeforeScreenshot();
                _context5.next = 3;
                return NAVIGATOR.mediaDevices.getDisplayMedia({
                  video: {
                    width: WINDOW.innerWidth * WINDOW.devicePixelRatio,
                    height: WINDOW.innerHeight * WINDOW.devicePixelRatio
                  },
                  audio: false,
                  // @ts-expect-error experimental flags: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#prefercurrenttab
                  monitorTypeSurfaces: 'exclude',
                  preferCurrentTab: true,
                  selfBrowserSurface: 'include',
                  surfaceSwitching: 'exclude'
                });
              case 3:
                stream = _context5.sent;
                video = DOCUMENT.createElement('video');
                _context5.next = 7;
                return new Promise(function (resolve, reject) {
                  video.srcObject = stream;
                  video.onloadedmetadata = function () {
                    onScreenshot(video);
                    stream.getTracks().forEach(function (track) {
                      return track.stop();
                    });
                    resolve();
                  };
                  video.play().catch(reject);
                });
              case 7:
                onAfterScreenshot();
              case 8:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function takeScreenshot() {
          return _ref19.apply(this, arguments);
        };
      }();
      takeScreenshot().catch(onError);
    }, []);
  };
}
var CROP_BUTTON_SIZE = 30;
var CROP_BUTTON_BORDER = 3;
var CROP_BUTTON_OFFSET = CROP_BUTTON_SIZE + CROP_BUTTON_BORDER;
var DPI = WINDOW.devicePixelRatio;
var constructRect = function constructRect(box) {
  return {
    x: Math.min(box.startX, box.endX),
    y: Math.min(box.startY, box.endY),
    width: Math.abs(box.startX - box.endX),
    height: Math.abs(box.startY - box.endY)
  };
};
var getContainedSize = function getContainedSize(img) {
  var imgClientHeight = img.clientHeight;
  var imgClientWidth = img.clientWidth;
  var ratio = img.width / img.height;
  var width = imgClientHeight * ratio;
  var height = imgClientHeight;
  if (width > imgClientWidth) {
    width = imgClientWidth;
    height = imgClientWidth / ratio;
  }
  var x = (imgClientWidth - width) / 2;
  var y = (imgClientHeight - height) / 2;
  return {
    startX: x,
    startY: y,
    endX: width + x,
    endY: height + y
  };
};
function ScreenshotEditorFactory(_ref20) {
  var h = _ref20.h,
    hooks = _ref20.hooks,
    imageBuffer = _ref20.imageBuffer,
    dialog = _ref20.dialog,
    options = _ref20.options;
  var useTakeScreenshot = useTakeScreenshotFactory({
    hooks: hooks
  });
  return function ScreenshotEditor(_ref21) {
    var onError = _ref21.onError;
    var styles = hooks.useMemo(function () {
      return {
        __html: createScreenshotInputStyles(options.styleNonce).innerText
      };
    }, []);
    var CropCorner = CropCornerFactory({
      h: h
    });
    var canvasContainerRef = hooks.useRef(null);
    var cropContainerRef = hooks.useRef(null);
    var croppingRef = hooks.useRef(null);
    var _hooks$useState = hooks.useState({
        startX: 0,
        startY: 0,
        endX: 0,
        endY: 0
      }),
      _hooks$useState2 = _slicedToArray(_hooks$useState, 2),
      croppingRect = _hooks$useState2[0],
      setCroppingRect = _hooks$useState2[1];
    var _hooks$useState3 = hooks.useState(false),
      _hooks$useState4 = _slicedToArray(_hooks$useState3, 2),
      confirmCrop = _hooks$useState4[0],
      setConfirmCrop = _hooks$useState4[1];
    var _hooks$useState5 = hooks.useState(false),
      _hooks$useState6 = _slicedToArray(_hooks$useState5, 2),
      isResizing = _hooks$useState6[0],
      setIsResizing = _hooks$useState6[1];
    hooks.useEffect(function () {
      WINDOW.addEventListener('resize', resizeCropper, false);
    }, []);
    function resizeCropper() {
      var cropper = croppingRef.current;
      var imageDimensions = constructRect(getContainedSize(imageBuffer));
      if (cropper) {
        cropper.width = imageDimensions.width * DPI;
        cropper.height = imageDimensions.height * DPI;
        cropper.style.width = "".concat(imageDimensions.width, "px");
        cropper.style.height = "".concat(imageDimensions.height, "px");
        var ctx = cropper.getContext('2d');
        if (ctx) {
          ctx.scale(DPI, DPI);
        }
      }
      var cropButton = cropContainerRef.current;
      if (cropButton) {
        cropButton.style.width = "".concat(imageDimensions.width, "px");
        cropButton.style.height = "".concat(imageDimensions.height, "px");
      }
      setCroppingRect({
        startX: 0,
        startY: 0,
        endX: imageDimensions.width,
        endY: imageDimensions.height
      });
    }
    hooks.useEffect(function () {
      var cropper = croppingRef.current;
      if (!cropper) {
        return;
      }
      var ctx = cropper.getContext('2d');
      if (!ctx) {
        return;
      }
      var imageDimensions = constructRect(getContainedSize(imageBuffer));
      var croppingBox = constructRect(croppingRect);
      ctx.clearRect(0, 0, imageDimensions.width, imageDimensions.height);

      // draw gray overlay around the selection
      ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
      ctx.fillRect(0, 0, imageDimensions.width, imageDimensions.height);
      ctx.clearRect(croppingBox.x, croppingBox.y, croppingBox.width, croppingBox.height);

      // draw selection border
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 3;
      ctx.strokeRect(croppingBox.x + 1, croppingBox.y + 1, croppingBox.width - 2, croppingBox.height - 2);
      ctx.strokeStyle = '#000000';
      ctx.lineWidth = 1;
      ctx.strokeRect(croppingBox.x + 3, croppingBox.y + 3, croppingBox.width - 6, croppingBox.height - 6);
    }, [croppingRect]);
    function onGrabButton(e, corner) {
      setConfirmCrop(false);
      setIsResizing(true);
      var handleMouseMove = makeHandleMouseMove(corner);
      var handleMouseUp = function handleMouseUp() {
        DOCUMENT.removeEventListener('mousemove', handleMouseMove);
        DOCUMENT.removeEventListener('mouseup', handleMouseUp);
        setConfirmCrop(true);
        setIsResizing(false);
      };
      DOCUMENT.addEventListener('mouseup', handleMouseUp);
      DOCUMENT.addEventListener('mousemove', handleMouseMove);
    }
    var makeHandleMouseMove = hooks.useCallback(function (corner) {
      return function (e) {
        if (!croppingRef.current) {
          return;
        }
        var cropCanvas = croppingRef.current;
        var cropBoundingRect = cropCanvas.getBoundingClientRect();
        var mouseX = e.clientX - cropBoundingRect.x;
        var mouseY = e.clientY - cropBoundingRect.y;
        switch (corner) {
          case 'top-left':
            setCroppingRect(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                startX: Math.min(Math.max(0, mouseX), prev.endX - CROP_BUTTON_OFFSET),
                startY: Math.min(Math.max(0, mouseY), prev.endY - CROP_BUTTON_OFFSET)
              });
            });
            break;
          case 'top-right':
            setCroppingRect(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                endX: Math.max(Math.min(mouseX, cropCanvas.width / DPI), prev.startX + CROP_BUTTON_OFFSET),
                startY: Math.min(Math.max(0, mouseY), prev.endY - CROP_BUTTON_OFFSET)
              });
            });
            break;
          case 'bottom-left':
            setCroppingRect(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                startX: Math.min(Math.max(0, mouseX), prev.endX - CROP_BUTTON_OFFSET),
                endY: Math.max(Math.min(mouseY, cropCanvas.height / DPI), prev.startY + CROP_BUTTON_OFFSET)
              });
            });
            break;
          case 'bottom-right':
            setCroppingRect(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                endX: Math.max(Math.min(mouseX, cropCanvas.width / DPI), prev.startX + CROP_BUTTON_OFFSET),
                endY: Math.max(Math.min(mouseY, cropCanvas.height / DPI), prev.startY + CROP_BUTTON_OFFSET)
              });
            });
            break;
        }
      };
    }, []);

    // DRAGGING FUNCTIONALITY.
    var initialPositionRef = hooks.useRef({
      initialX: 0,
      initialY: 0
    });
    function onDragStart(e) {
      if (isResizing) return;
      initialPositionRef.current = {
        initialX: e.clientX,
        initialY: e.clientY
      };
      var handleMouseMove = function handleMouseMove(moveEvent) {
        var cropCanvas = croppingRef.current;
        if (!cropCanvas) return;
        var deltaX = moveEvent.clientX - initialPositionRef.current.initialX;
        var deltaY = moveEvent.clientY - initialPositionRef.current.initialY;
        setCroppingRect(function (prev) {
          // Math.max stops it from going outside of the borders
          var newStartX = Math.max(0, Math.min(prev.startX + deltaX, cropCanvas.width / DPI - (prev.endX - prev.startX)));
          var newStartY = Math.max(0, Math.min(prev.startY + deltaY, cropCanvas.height / DPI - (prev.endY - prev.startY)));
          // Don't want to change size, just position
          var newEndX = newStartX + (prev.endX - prev.startX);
          var newEndY = newStartY + (prev.endY - prev.startY);
          initialPositionRef.current.initialX = moveEvent.clientX;
          initialPositionRef.current.initialY = moveEvent.clientY;
          return {
            startX: newStartX,
            startY: newStartY,
            endX: newEndX,
            endY: newEndY
          };
        });
      };
      var handleMouseUp = function handleMouseUp() {
        DOCUMENT.removeEventListener('mousemove', handleMouseMove);
        DOCUMENT.removeEventListener('mouseup', handleMouseUp);
      };
      DOCUMENT.addEventListener('mousemove', handleMouseMove);
      DOCUMENT.addEventListener('mouseup', handleMouseUp);
    }
    function submit() {
      var cutoutCanvas = DOCUMENT.createElement('canvas');
      var imageBox = constructRect(getContainedSize(imageBuffer));
      var croppingBox = constructRect(croppingRect);
      cutoutCanvas.width = croppingBox.width * DPI;
      cutoutCanvas.height = croppingBox.height * DPI;
      var cutoutCtx = cutoutCanvas.getContext('2d');
      if (cutoutCtx && imageBuffer) {
        cutoutCtx.drawImage(imageBuffer, croppingBox.x / imageBox.width * imageBuffer.width, croppingBox.y / imageBox.height * imageBuffer.height, croppingBox.width / imageBox.width * imageBuffer.width, croppingBox.height / imageBox.height * imageBuffer.height, 0, 0, cutoutCanvas.width, cutoutCanvas.height);
      }
      var ctx = imageBuffer.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, imageBuffer.width, imageBuffer.height);
        imageBuffer.width = cutoutCanvas.width;
        imageBuffer.height = cutoutCanvas.height;
        imageBuffer.style.width = "".concat(croppingBox.width, "px");
        imageBuffer.style.height = "".concat(croppingBox.height, "px");
        ctx.drawImage(cutoutCanvas, 0, 0);
        resizeCropper();
      }
    }
    useTakeScreenshot({
      onBeforeScreenshot: hooks.useCallback(function () {
        dialog.el.style.display = 'none';
      }, []),
      onScreenshot: hooks.useCallback(function (imageSource) {
        var context = imageBuffer.getContext('2d');
        if (!context) {
          throw new Error('Could not get canvas context');
        }
        imageBuffer.width = imageSource.videoWidth;
        imageBuffer.height = imageSource.videoHeight;
        imageBuffer.style.width = '100%';
        imageBuffer.style.height = '100%';
        context.drawImage(imageSource, 0, 0);
      }, [imageBuffer]),
      onAfterScreenshot: hooks.useCallback(function () {
        dialog.el.style.display = 'block';
        var container = canvasContainerRef.current;
        container && container.appendChild(imageBuffer);
        resizeCropper();
      }, []),
      onError: hooks.useCallback(function (error) {
        dialog.el.style.display = 'block';
        onError(error);
      }, [])
    });
    return h('div', {
      class: "editor"
    }, h('style', {
      nonce: options.styleNonce,
      dangerouslySetInnerHTML: styles
    }), h('div', {
      class: "editor__canvas-container",
      ref: canvasContainerRef
    }, h('div', {
      class: "editor__crop-container",
      style: {
        position: 'absolute',
        zIndex: 1
      },
      ref: cropContainerRef
    }, h('canvas', {
      onMouseDown: onDragStart,
      style: {
        position: 'absolute',
        cursor: confirmCrop ? 'move' : 'auto'
      },
      ref: croppingRef
    }), h(CropCorner, {
      left: croppingRect.startX - CROP_BUTTON_BORDER,
      top: croppingRect.startY - CROP_BUTTON_BORDER,
      onGrabButton: onGrabButton,
      corner: "top-left"
    }), h(CropCorner, {
      left: croppingRect.endX - CROP_BUTTON_SIZE + CROP_BUTTON_BORDER,
      top: croppingRect.startY - CROP_BUTTON_BORDER,
      onGrabButton: onGrabButton,
      corner: "top-right"
    }), h(CropCorner, {
      left: croppingRect.startX - CROP_BUTTON_BORDER,
      top: croppingRect.endY - CROP_BUTTON_SIZE + CROP_BUTTON_BORDER,
      onGrabButton: onGrabButton,
      corner: "bottom-left"
    }), h(CropCorner, {
      left: croppingRect.endX - CROP_BUTTON_SIZE + CROP_BUTTON_BORDER,
      top: croppingRect.endY - CROP_BUTTON_SIZE + CROP_BUTTON_BORDER,
      onGrabButton: onGrabButton,
      corner: "bottom-right"
    }), h('div', {
      style: {
        left: Math.max(0, croppingRect.endX - 191),
        top: Math.max(0, croppingRect.endY + 8),
        display: confirmCrop ? 'flex' : 'none'
      },
      class: "editor__crop-btn-group"
    }, h('button', {
      onClick: function onClick(e) {
        e.preventDefault();
        if (croppingRef.current) {
          setCroppingRect({
            startX: 0,
            startY: 0,
            endX: croppingRef.current.width / DPI,
            endY: croppingRef.current.height / DPI
          });
        }
        setConfirmCrop(false);
      },
      class: "btn btn--default"
    }, options.cancelButtonLabel), h('button', {
      onClick: function onClick(e) {
        e.preventDefault();
        submit();
        setConfirmCrop(false);
      },
      class: "btn btn--primary"
    }, options.confirmButtonLabel)))));
  };
}
var feedbackScreenshotIntegration = function feedbackScreenshotIntegration() {
  return {
    name: 'FeedbackScreenshot',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setupOnce: function setupOnce() {},
    createInput: function createInput(_ref22) {
      var h = _ref22.h,
        hooks = _ref22.hooks,
        dialog = _ref22.dialog,
        options = _ref22.options;
      var imageBuffer = DOCUMENT.createElement('canvas');
      return {
        input: ScreenshotEditorFactory({
          h: h,
          hooks: hooks,
          imageBuffer: imageBuffer,
          dialog: dialog,
          options: options
        }),
        // eslint-disable-line @typescript-eslint/no-explicit-any

        value: function () {
          var _value = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
            var blob, data, attachment;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return new Promise(function (resolve) {
                    imageBuffer.toBlob(resolve, 'image/png');
                  });
                case 2:
                  blob = _context6.sent;
                  if (!blob) {
                    _context6.next = 11;
                    break;
                  }
                  _context6.t0 = Uint8Array;
                  _context6.next = 7;
                  return blob.arrayBuffer();
                case 7:
                  _context6.t1 = _context6.sent;
                  data = new _context6.t0(_context6.t1);
                  attachment = {
                    data: data,
                    filename: 'screenshot.png',
                    contentType: 'application/png'
                    // attachmentType?: string;
                  };
                  return _context6.abrupt("return", attachment);
                case 11:
                  return _context6.abrupt("return", undefined);
                case 12:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          function value() {
            return _value.apply(this, arguments);
          }
          return value;
        }()
      };
    }
  };
};
export { buildFeedbackIntegration, feedbackModalIntegration, feedbackScreenshotIntegration, getFeedback, sendFeedback };